export const ticketFilters = ['Current', 'Previous'];
export const homeFilters = [
  {
    id: 1,
    name: 'For You',
    filterBy: ''
  },
  {
    id: 2,
    name: 'Trending',
    filterBy: 'trending'
  },
  {
    id: 3,
    name: 'Categories',
    filterBy: 'new'
  },
  {
    id: 4,
    name: 'Live',
    filterBy: 'live'
  }
];
